/**
 * DevToolsPanel Constants
 */

import type { DevToolsTabItem } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/index.types';

const SCROLLING_CONTENT = 'm-0 h-full overflow-auto p-3.5 animate-in fade-in slide-in-from-bottom-1 duration-[180ms]';

export const TAB_ITEMS: DevToolsTabItem[] = [
  { value: 'calls', label: 'Calls', contentClassName: SCROLLING_CONTENT },
  {
    value: 'events',
    label: 'Events',
    // Events pins a header and a footer and scrolls only the list between them.
    contentClassName: 'm-0 flex h-full flex-col overflow-hidden p-3.5 animate-in fade-in slide-in-from-bottom-1 duration-[180ms]',
  },
  {
    value: 'sip',
    label: 'SIP',
    hasIndicator: true,
    contentClassName: SCROLLING_CONTENT,
  },
  {
    value: 'webrtc',
    label: 'WebRTC',
    hasIndicator: true,
    contentClassName: SCROLLING_CONTENT,
  },
  { value: 'devices', label: 'Devices', contentClassName: SCROLLING_CONTENT },
  { value: 'debug', label: 'Debug', contentClassName: SCROLLING_CONTENT },
];
